export default __webpack_public_path__ + "static/media/white.f110bc75.svg";